import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth
export const login = (data) => axios.post(`${API}/auth/login`, data);
export const register = (data) => axios.post(`${API}/auth/register`, data);
export const getMe = () => axios.get(`${API}/auth/me`);
export const changePassword = (data) => axios.put(`${API}/auth/change-password`, data);

// Membership
export const requestMembership = (data) => axios.post(`${API}/membership/request`, data);
export const getMyMembership = () => axios.get(`${API}/membership/my`);
export const getPendingMemberships = () => axios.get(`${API}/membership/pending`);
export const validateMembership = (id) => axios.put(`${API}/membership/${id}/validate`);
export const rejectMembership = (id) => axios.put(`${API}/membership/${id}/reject`);

// Categories
export const getCategories = () => axios.get(`${API}/categories`);
export const createCategory = (data) => axios.post(`${API}/categories`, data);
export const updateCategory = (id, data) => axios.put(`${API}/categories/${id}`, data);
export const deleteCategory = (id) => axios.delete(`${API}/categories/${id}`);

// Destinations
export const getDestinations = () => axios.get(`${API}/destinations`);
export const createDestination = (data) => axios.post(`${API}/destinations`, data);
export const getDestination = (slug) => axios.get(`${API}/destinations/${slug}`);

// Partners
export const getPartners = () => axios.get(`${API}/partners`);
export const createPartner = (data) => axios.post(`${API}/partners`, data);

// Deals
export const getDeals = (params = {}) => axios.get(`${API}/deals`, { params });
export const getDealsAdmin = (params = {}) => axios.get(`${API}/deals/admin`, { params });
export const createDeal = (data) => axios.post(`${API}/deals`, data);
export const updateDeal = (id, data) => axios.put(`${API}/deals/${id}`, data);
export const deleteDeal = (id) => axios.delete(`${API}/deals/${id}`);
export const trackDeal = (id, action) => axios.post(`${API}/deals/${id}/track?action=${action}`);

// Articles
// Phase E2 (2026-09-21) — `lng` optionnel : la liste renvoie déjà des variantes
// localisées quand présentes (fallback FR sinon, jamais de faux badge).
export const getArticles = (params = {}) => axios.get(`${API}/articles`, { params });
export const getArticle = (id, lng) => axios.get(`${API}/articles/${id}`, { params: lng ? { lng } : {} });
export const getAdminArticles = (params = {}) => axios.get(`${API}/articles/admin`, { params });

// Generic editorial PDF export (any content type: article, guide, trip_report, review…)
export const exportContentPdf = (contentType, idOrSlug) =>
  axios.get(`${API}/content/${contentType}/${encodeURIComponent(idOrSlug)}/export-pdf`, {
    responseType: "blob",
  });
export const createArticle = (data) => axios.post(`${API}/articles`, data);
export const updateArticle = (id, data) => axios.put(`${API}/articles/${id}`, data);
export const deleteArticle = (id) => axios.delete(`${API}/articles/${id}`);
export const generateArticle = (data) => axios.post(`${API}/articles/generate`, data);
export const reviseArticle = (data) => axios.post(`${API}/articles/revise`, data);
// Article JSON Import
export const validateArticleImport = (data) => axios.post(`${API}/articles/import/validate`, data);
export const importArticle = (data) => axios.post(`${API}/articles/import`, data);

// AI
export const getAIModels = () => axios.get(`${API}/ai/models`);
export const getAIStatus = () => axios.get(`${API}/ai/status`);
export const suggestPhotoOrder = (photoIds) => axios.post(`${API}/ai/suggest-photo-order`, photoIds);
export const generateDraft = (data) => axios.post(`${API}/ai/generate-draft`, data);
export const suggestContent = (photoIds) => axios.post(`${API}/ai/suggest-content`, { photo_ids: photoIds });
export const getAICacheStats = () => axios.get(`${API}/ai/cache/stats`);
export const clearAICache = () => axios.delete(`${API}/ai/cache/clear`);

// Photos
export const uploadPhoto = (formData) => axios.post(`${API}/photos/upload`, formData, {
  headers: { "Content-Type": "multipart/form-data" }
});
export const getPhotos = (params = {}) => axios.get(`${API}/photos`, { params });
export const updatePhoto = (id, data) => axios.put(`${API}/photos/${id}`, data);
export const deletePhoto = (id) => axios.delete(`${API}/photos/${id}`);
export const rotatePhoto = (id, action) => axios.put(`${API}/photos/${id}/rotate`, { action });
export const getImportLogs = () => axios.get(`${API}/photos/import-logs`);

// Albums
export const getAlbums = () => axios.get(`${API}/albums`);
export const createAlbum = (data) => axios.post(`${API}/albums`, data);
export const getAlbum = (id) => axios.get(`${API}/albums/${id}`);
export const updateAlbum = (id, data) => axios.put(`${API}/albums/${id}`, data);
export const deleteAlbum = (id) => axios.delete(`${API}/albums/${id}`);
export const getAlbumPhotos = (id) => axios.get(`${API}/albums/${id}/photos`);
export const addPhotosToAlbum = (albumId, photoIds) => axios.post(`${API}/albums/${albumId}/photos`, photoIds);
export const removePhotosFromAlbum = (albumId, photoIds) => axios.delete(`${API}/albums/${albumId}/photos`, { data: photoIds });

// Comments
export const getArticleComments = (articleId) => axios.get(`${API}/comments/article/${articleId}`);
export const createComment = (data) => axios.post(`${API}/comments`, data);
export const getPendingComments = () => axios.get(`${API}/comments/pending`);
export const moderateComment = (id, status) => axios.put(`${API}/comments/${id}/moderate?status=${status}`);

// Stats
export const getStats = () => axios.get(`${API}/stats`);
export const getAdminStats = () => axios.get(`${API}/stats/admin`);

// Banners
export const getBanners = (params = {}) => axios.get(`${API}/banners`, { params });
export const createBanner = (data) => axios.post(`${API}/banners`, data);
export const updateBanner = (id, data) => axios.put(`${API}/banners/${id}`, data);
export const deleteBanner = (id) => axios.delete(`${API}/banners/${id}`);

// Settings
export const getSettings = () => axios.get(`${API}/settings`);
export const updateSettings = (data) => axios.put(`${API}/settings`, data);

// Product Reviews (Tests Produits)
export const getProductReviews = (params = {}) => axios.get(`${API}/product-reviews`, { params });
export const getProductReview = (id) => axios.get(`${API}/product-reviews/${id}`);
export const getProductCategories = (params = {}) => axios.get(`${API}/product-reviews/categories`, { params });
export const updateCategoryVisibility = (category, visible) => axios.put(`${API}/product-reviews/categories/visibility`, { category, visible });
export const createProductReview = (data) => axios.post(`${API}/product-reviews`, data);
export const generateProductReview = (data) => axios.post(`${API}/product-reviews/generate`, data);
export const updateProductReview = (id, data) => axios.put(`${API}/product-reviews/${id}`, data);
export const deleteProductReview = (id) => axios.delete(`${API}/product-reviews/${id}`);

// Mobile Upload
export const generateApiKey = () => axios.post(`${API}/mobile/generate-api-key`);
export const revokeApiKey = () => axios.delete(`${API}/mobile/revoke-api-key`);
export const getMyApiKey = () => axios.get(`${API}/mobile/my-key`);

// Site Sections (Visibility Management)
export const getSiteSections = (params = {}) => axios.get(`${API}/site-sections`, { params });
export const updateSectionVisibility = (sectionId, visible, options = {}) => axios.put(`${API}/site-sections/${sectionId}/visibility`, { visible, ...options });
export const createSiteSection = (data) => axios.post(`${API}/site-sections`, data);
export const updateSiteSection = (sectionId, data) => axios.put(`${API}/site-sections/${sectionId}`, data);
export const deleteSiteSection = (sectionId) => axios.delete(`${API}/site-sections/${sectionId}`);

// Cloudinary
export const getCloudinarySignature = (folder = "photos", resourceType = "image") => 
  axios.get(`${API}/cloudinary/signature`, { params: { folder, resource_type: resourceType } });
export const getCloudinaryStatus = () => axios.get(`${API}/cloudinary/status`);
export const getCloudinaryFolders = () => axios.get(`${API}/cloudinary/folders`);
export const saveCloudinaryPhoto = (data) => axios.post(`${API}/photos/cloudinary`, data);
export const deleteCloudinaryPhoto = (photoId) => axios.delete(`${API}/photos/cloudinary/${photoId}`);
export const batchImportPhotos = (source) => axios.post(`${API}/photos/batch-import`, source);
export const syncFromCloudinary = (folder = "") => axios.post(`${API}/photos/sync-cloudinary`, { folder });

// Admin User Management
export const getAdminUsers = (params = {}) => axios.get(`${API}/admin/users`, { params });
export const getAdminUser = (userId) => axios.get(`${API}/admin/users/${userId}`);
export const createAdminUser = (data) => axios.post(`${API}/admin/users`, data);
export const updateAdminUser = (userId, data) => axios.put(`${API}/admin/users/${userId}`, data);
export const deleteAdminUser = (userId) => axios.delete(`${API}/admin/users/${userId}`);
export const resetUserPassword = (userId, newPassword) => axios.post(`${API}/admin/users/${userId}/reset-password`, { new_password: newPassword });
export const suspendUser = (userId) => axios.post(`${API}/admin/users/${userId}/suspend`);
export const reactivateUser = (userId) => axios.post(`${API}/admin/users/${userId}/reactivate`);
export const getAdminRoles = () => axios.get(`${API}/admin/roles`);
export const getAdminUsersStats = () => axios.get(`${API}/admin/users/stats`);

// Init
export const initData = () => axios.post(`${API}/init-data`);

// Trips (voyages multi-jours) - Bloc 3
export const getTrips = (params = {}) => axios.get(`${API}/trips`, { params });
export const getTripsAdmin = () => axios.get(`${API}/trips/admin`);
export const getTripBySlug = (slug) => axios.get(`${API}/trips/${slug}`);
export const getTripDay = (tripId, daySlug) => axios.get(`${API}/trips/${tripId}/days/${daySlug}`);
export const createTrip = (data) => axios.post(`${API}/trips`, data);
export const updateTrip = (id, data) => axios.put(`${API}/trips/${id}`, data);
export const deleteTrip = (id) => axios.delete(`${API}/trips/${id}`);
export const createTripDay = (tripId, data) => axios.post(`${API}/trips/${tripId}/days`, data);
export const updateTripDay = (tripId, dayId, data) => axios.put(`${API}/trips/${tripId}/days/${dayId}`, data);
export const deleteTripDay = (tripId, dayId) => axios.delete(`${API}/trips/${tripId}/days/${dayId}`);
export const reorderTripDays = (tripId, dayIds) => axios.post(`${API}/trips/${tripId}/reorder-days`, { day_ids: dayIds });

// Geocode (Bloc 4)
export const geocode = (q) => axios.get(`${API}/geocode`, { params: { q } });

// Media (mediatheque unifiee) - Bloc 2 + 7 + 8 + 9
export const getMediaList = (params = {}) => axios.get(`${API}/media`, { params });
export const getMedia = (id) => axios.get(`${API}/media/${id}`);
export const uploadVideo = (formData) => axios.post(`${API}/media/upload-video`, formData, { headers: { "Content-Type": "multipart/form-data" } });
export const uploadMediaBatch = (formData) => axios.post(`${API}/media/upload-batch`, formData, { headers: { "Content-Type": "multipart/form-data" } });
export const batchAttachMedia = (data) => axios.post(`${API}/media/batch-attach`, data);
export const attachMedia = (id, data) => axios.post(`${API}/media/${id}/attach`, data);
export const detachMedia = (id, entityType, entityId) => axios.delete(`${API}/media/${id}/attach`, { params: { entity_type: entityType, entity_id: entityId } });
export const deleteMedia = (id) => axios.delete(`${API}/media/${id}`);
export const updateMediaMeta = (id, data) => axios.put(`${API}/media/${id}`, data);
export const setMediaWatermark = (id, data) => axios.put(`${API}/media/${id}/watermark`, data);
export const setMediaBlur = (id, data) => axios.put(`${API}/media/${id}/blur`, data);
export const runWatermarkHistoricMigration = () => axios.post(`${API}/media/watermark-historic-migration`);
export const getWatermarkHistoricPending = () => axios.get(`${API}/media/watermark-historic-pending-count`);

// Memberships (adherents ITERCATUS) - separated from Users
export const getMemberships = (params = {}) => axios.get(`${API}/memberships`, { params });
export const getMembership = (id) => axios.get(`${API}/memberships/${id}`);
export const createMembership = (data) => axios.post(`${API}/memberships`, data);
export const updateMembership = (id, data) => axios.put(`${API}/memberships/${id}`, data);
export const linkMembershipUser = (id, userId) => axios.post(`${API}/memberships/${id}/link-user`, { user_id: userId });
export const renewMembership = (id, data) => axios.post(`${API}/memberships/${id}/renew`, data);

// Editorial AI (Trips) - Bloc IA Carnets
export const aiGenerateDay = (tripId, dayId, payload) => axios.post(`${API}/trips/${tripId}/days/${dayId}/generate`, payload);
export const aiGenerateTripIntro = (tripId, payload = {}) => axios.post(`${API}/trips/${tripId}/generate-intro`, payload);
export const aiGenerateCaption = (mediaId, payload = {}) => axios.post(`${API}/media/${mediaId}/generate-caption`, payload);
export const aiBlockAction = (payload) => axios.post(`${API}/ai/block-action`, payload);
export const exportTripDay = (tripId, dayId) => axios.get(`${API}/trips/${tripId}/days/${dayId}/export`);
export const exportTripDayPackage = (tripId, dayId) => axios.get(`${API}/trips/${tripId}/days/${dayId}/export-package`, { responseType: "blob" });
export const importTripDayEditorial = (tripId, dayId, payload, preview = false) =>
  axios.post(`${API}/trips/${tripId}/days/${dayId}/import-editorial`, payload, { params: { preview } });

// Upload batch (Carnets V3 - reuse Article-like workflow)
const _uploadMediaBatchV3 = (files, albumId = null) => {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  if (albumId) fd.append("album_id", albumId);
  return axios.post(`${API}/media/upload-batch`, fd, { headers: { "Content-Type": "multipart/form-data" } });
};
export const uploadMediaBatchFromFiles = _uploadMediaBatchV3;
export const syncTripDayMedia = (tripId, dayId) => axios.post(`${API}/trips/${tripId}/days/${dayId}/sync-media`);

// Rotation media
export const rotateMedia = (mediaId, payload) => axios.post(`${API}/media/${mediaId}/rotate`, payload);

// Cloudinary monitoring (Bloc P2)
export const getCloudinaryUsage = () => axios.get(`${API}/admin/cloudinary-usage`);
export const refreshCloudinaryUsage = () => axios.post(`${API}/admin/cloudinary-usage/refresh`);
export const getAdminAlerts = (dismissed = false) => axios.get(`${API}/admin/alerts`, { params: { dismissed } });

// Membership card / QR (Phase B)
export const getMembershipCard = (mid) => axios.get(`${API}/memberships/${mid}/card`);
export const regenerateMembershipQr = (mid) => axios.post(`${API}/memberships/${mid}/regenerate-qr`);
export const verifyMember = (token) => axios.get(`${API}/verify-member/${token}`);
export const suspendMembership = (mid) => axios.post(`${API}/memberships/${mid}/suspend`);
export const reactivateMembership = (mid) => axios.post(`${API}/memberships/${mid}/reactivate`);
export const archiveMembership = (mid) => axios.post(`${API}/memberships/${mid}/archive`);
export const hardDeleteMembership = (mid, confirmMemberNumber) => axios.delete(`${API}/memberships/${mid}/hard-delete`, { data: { confirm_member_number: confirmMemberNumber } });
export const refundMembershipPayment = (mid, reason) => axios.post(`${API}/memberships/${mid}/refund`, { reason });
export const requestMembershipPayment = (mid, payload) => axios.post(`${API}/memberships/${mid}/request-payment`, payload || {});
export const listAdherentsPayments = (params = {}) => axios.get(`${API}/adherents/payments`, { params });

// Diffusion sociale (Phase C)
export const getSocialAccounts = () => axios.get(`${API}/social/accounts`);
export const updateSocialAccount = (platform, payload) => axios.put(`${API}/social/accounts/${platform}`, payload);
export const getSocialPublications = (params = {}) => axios.get(`${API}/social/publications`, { params });
export const getSocialPendingCount = () => axios.get(`${API}/social/publications/pending-count`);
export const getSocialPublication = (pid) => axios.get(`${API}/social/publications/${pid}`);
export const updateSocialPublication = (pid, payload) => axios.put(`${API}/social/publications/${pid}`, payload);
export const regenerateSocialPublication = (pid) => axios.post(`${API}/social/publications/${pid}/regenerate`);
export const approveSocialPublication = (pid) => axios.post(`${API}/social/publications/${pid}/approve`);
export const publishSocialPublication = (pid) => axios.post(`${API}/social/publications/${pid}/publish`);
export const deleteSocialPublication = (pid) => axios.delete(`${API}/social/publications/${pid}`);
export const prepareSocialForSource = (sourceType, sourceId) => axios.post(`${API}/social/prepare/${sourceType}/${sourceId}`);
export const dismissAdminAlert = (id) => axios.post(`${API}/admin/alerts/${id}/dismiss`);

// Escales Privileges (offres partenaires reservees adherents)
export const getPublicPrivileges = (params = {}) => axios.get(`${API}/privileges`, { params });
export const getPublicPrivilege = (id) => axios.get(`${API}/privileges/${id}`);
export const revealPrivilege = (id) => axios.post(`${API}/privileges/${id}/reveal`);
export const getFeaturedPrivilegePopup = () => axios.get(`${API}/privileges/featured-popup`, { validateStatus: (s) => s === 200 || s === 204 });
export const getAdminPrivileges = (params = {}) => axios.get(`${API}/admin/privileges`, { params });
export const getAdminPrivilege = (id) => axios.get(`${API}/admin/privileges/${id}`);
export const createAdminPrivilege = (data) => axios.post(`${API}/admin/privileges`, data);
export const updateAdminPrivilege = (id, data) => axios.put(`${API}/admin/privileges/${id}`, data);
export const deleteAdminPrivilege = (id) => axios.delete(`${API}/admin/privileges/${id}`);
export const duplicateAdminPrivilege = (id) => axios.post(`${API}/admin/privileges/${id}/duplicate`);
export const activateAdminPrivilege = (id) => axios.post(`${API}/admin/privileges/${id}/activate`);
export const suspendAdminPrivilege = (id) => axios.post(`${API}/admin/privileges/${id}/suspend`);
export const archiveAdminPrivilege = (id) => axios.post(`${API}/admin/privileges/${id}/archive`);
export const scheduleAdminPrivilege = (id, data) => axios.post(`${API}/admin/privileges/${id}/schedule`, data);
export const getBenefitUsageLog = (params = {}) => axios.get(`${API}/admin/benefit-usage-log`, { params });

// Phase 13.c — Espace membre (compte personnel /api/me)
export const getMyMemberships = () => axios.get(`${API}/me/memberships`);
export const getMyDonations = () => axios.get(`${API}/me/donations`);
export const getMyReceipts = () => axios.get(`${API}/me/receipts`);
export const downloadMyReceiptPdf = (receiptId) => axios.get(`${API}/me/receipts/${receiptId}/pdf`, { responseType: "blob" });
export const getMyAuthorProfile = () => axios.get(`${API}/me/author-profile`);
export const updateMyAuthorProfile = (data) => axios.put(`${API}/me/author-profile`, data);

// Phase 13.c — Blue Assisted Publishing (admin/editor)
export const getBlueDrafts = (params = {}) => axios.get(`${API}/admin/blue-publishing/drafts`, { params });
export const getBlueDraft = (id) => axios.get(`${API}/admin/blue-publishing/drafts/${id}`);
export const updateBlueDraft = (id, data) => axios.put(`${API}/admin/blue-publishing/drafts/${id}`, data);
export const approveBlueDraft = (id) => axios.post(`${API}/admin/blue-publishing/drafts/${id}/approve`);
export const rejectBlueDraft = (id, reason) => axios.post(`${API}/admin/blue-publishing/drafts/${id}/reject`, { reason });
export const publishBlueDraft = (id) => axios.post(`${API}/admin/blue-publishing/drafts/${id}/publish`);

// Phase 14 STEP 4.4 — audit assistance IA (admin only)
export const getArticleAiAssistance = (id) => axios.get(`${API}/articles/${id}/ai-assistance`);
export const updateArticleAiAssistance = (id, data) => axios.put(`${API}/articles/${id}/ai-assistance`, data);

// Hotfix 2026-09-21 — Super admin passkeys (WebAuthn), zone sécurité
export const getSuperAdminPasskeys = () =>
  axios.get(`${API}/admin/super-admin/webauthn/credentials`);
export const beginSuperAdminPasskeyRegistration = (data) =>
  axios.post(`${API}/admin/super-admin/webauthn/register/begin`, data);
export const finishSuperAdminPasskeyRegistration = (data) =>
  axios.post(`${API}/admin/super-admin/webauthn/register/finish`, data);

// Phase A édito (2026-09-21) — Lots d'importation médias
export const getMediaImportBatches = (params = {}) =>
  axios.get(`${API}/admin/media-batches`, { params });
export const getMediaImportBatch = (id) =>
  axios.get(`${API}/admin/media-batches/${id}`);
export const createMediaImportBatch = (data) =>
  axios.post(`${API}/admin/media-batches`, data);
export const updateMediaImportBatch = (id, data) =>
  axios.put(`${API}/admin/media-batches/${id}`, data);
export const deleteMediaImportBatch = (id) =>
  axios.delete(`${API}/admin/media-batches/${id}`);
export const attachMediaToBatch = (id, media_ids) =>
  axios.post(`${API}/admin/media-batches/${id}/attach`, { media_ids });
export const getBatchMedia = (id, params = {}) =>
  axios.get(`${API}/admin/media-batches/${id}/media`, { params });
export const setMediaUsage = (media_id, data) =>
  axios.post(`${API}/admin/media/${media_id}/usage`, data);

// Phase D1 édito (2026-09-21) — Détail lot, ventilation EXIF/lieu, incrémental
export const getBatchMediaEnriched = (id, params = {}) =>
  axios.get(`${API}/admin/media-batches/${id}/media-enriched`, { params });
export const detachMediaFromBatch = (id, media_ids) =>
  axios.post(`${API}/admin/media-batches/${id}/detach`, { media_ids });
export const runBatchIngest = (id, data = {}) =>
  axios.post(`${API}/admin/media-batches/${id}/ingest`, data);
export const reingestBatchUnclassified = (id) =>
  axios.post(`${API}/admin/media-batches/${id}/reingest-unclassified`);
export const setMediaDayAssignment = (media_id, data) =>
  axios.post(`${API}/admin/media/${media_id}/day-assignment`, data);
export const setMediaLocationOverride = (media_id, data) =>
  axios.post(`${API}/admin/media/${media_id}/location-override`, data);
export const assignDayBulk = (batch_id, data) =>
  axios.post(`${API}/admin/media-batches/${batch_id}/assign-day-bulk`, data);

// Phase D2 édito (2026-09-21) — Pont voyage ↔ Reporter + fiche depuis étape
export const openReporterFromTrip = (trip_id, focus_trip_day_id = null) =>
  axios.post(`${API}/reporter/sessions/from-trip`, { trip_id, focus_trip_day_id });

// Phase B édito (2026-09-21) — Détection usage médias + Corbeille sécurisée
export const getMediaUsageSummary = () =>
  axios.get(`${API}/admin/media-usage/summary`);
export const getMediaOrphans = (params = {}) =>
  axios.get(`${API}/admin/media-usage/orphans`, { params });
export const dryRunMediaTrash = () =>
  axios.post(`${API}/admin/media-trash/dry-run`);
export const moveMediaToTrash = (data) =>
  axios.post(`${API}/admin/media-trash/move`, data);
export const getMediaTrash = (params = {}) =>
  axios.get(`${API}/admin/media-trash`, { params });
export const restoreMediaFromTrash = (media_ids) =>
  axios.post(`${API}/admin/media-trash/restore`, { media_ids });
export const purgeMediaTrash = (data) =>
  axios.post(`${API}/admin/media-trash/purge`, data);

// Phase C édito (2026-09-21) — Fiches pratiques
export const listPracticalSheetsAdmin = (params = {}) =>
  axios.get(`${API}/admin/practical-sheets`, { params });
export const getPracticalSheetAdmin = (idOrSlug) =>
  axios.get(`${API}/admin/practical-sheets/${idOrSlug}`);
export const createPracticalSheet = (data) =>
  axios.post(`${API}/admin/practical-sheets`, data);
export const updatePracticalSheet = (id, data) =>
  axios.put(`${API}/admin/practical-sheets/${id}`, data);
export const deletePracticalSheet = (id) =>
  axios.delete(`${API}/admin/practical-sheets/${id}`);
export const prepareSheetWithBlue = (id) =>
  axios.post(`${API}/admin/practical-sheets/${id}/prepare-with-blue`);
export const applySheetBlueDraft = (id, updates) =>
  axios.post(`${API}/admin/practical-sheets/${id}/apply-blue-draft`, { updates });
export const getPracticalSheetPublic = (slug) =>
  axios.get(`${API}/practical-sheets/${slug}`);
export const getPracticalSheetPdfUrl = (slug) =>
  `${API}/practical-sheets/${slug}/pdf`;

// Phase H (2026-09-21) — Prospection partenaires (pilote Marseille).
// AUCUN email envoyé automatiquement : prepare-email génère un BROUILLON texte.
export const listPartnerProspects = (params = {}) =>
  axios.get(`${API}/admin/partner-prospects`, { params });
export const getPartnerProspectsDashboard = (destinationId) =>
  axios.get(`${API}/admin/partner-prospects/dashboard`, { params: destinationId ? { destination_id: destinationId } : {} });
export const getPartnerProspectsRelances = (destinationId, delayDays) =>
  axios.get(`${API}/admin/partner-prospects/relances`, {
    params: { ...(destinationId ? { destination_id: destinationId } : {}), ...(delayDays ? { delay_days: delayDays } : {}) },
  });
export const createPartnerProspect = (data) =>
  axios.post(`${API}/admin/partner-prospects`, data);
export const getPartnerProspect = (pid) =>
  axios.get(`${API}/admin/partner-prospects/${pid}`);
export const updatePartnerProspect = (pid, data) =>
  axios.patch(`${API}/admin/partner-prospects/${pid}`, data);
export const changePartnerProspectStatus = (pid, data) =>
  axios.post(`${API}/admin/partner-prospects/${pid}/status`, data);
export const preparePartnerProspectEmail = (pid, data = {}) =>
  axios.post(`${API}/admin/partner-prospects/${pid}/prepare-email`, data);

